import fs from "node:fs"
import path from "node:path"
import type { NextPage } from "next"
import Head from "next/head"
import type React from "react"
import { useState } from "react"

const languages = {
  English: "English",
  Svenska: "Svenska",
}

const Terms: NextPage<{ initialHtmlContent: string; initialHtmlContentSvenska: string }> = ({
  initialHtmlContent,
  initialHtmlContentSvenska,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState(languages.English)
  const [initialHtml, setInitialHtml] = useState(initialHtmlContent)

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedLanguage = event.target.value
    setSelectedLanguage(selectedLanguage)
    if (selectedLanguage === languages.English) {
      setInitialHtml(initialHtmlContent)
    } else if (selectedLanguage === languages.Svenska) {
      setInitialHtml(initialHtmlContentSvenska)
    }
  }

  return (
    <div>
      <Head>
        <title>Terms of Service</title>
        <link href="/favicon.ico" rel="icon" />
        <style>
          {`
            html, body {
              background-color: #FEFEF9;
            }
            `}
        </style>
      </Head>
      <div style={{ position: "absolute", right: 30, top: 45, backgroundColor: "#FEFEF9" }}>
        <div className="relative inline-block cursor-pointer select-none custom-select">
          <img alt="" className="align-middle" src="/assets/images/pepicons-pencil_internet.svg" />
          <select
            className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
            onChange={(e) => handleLanguageChange(e)}
            value={selectedLanguage}
          >
            {Object.keys(languages).map((language) => (
              <option key={language} value={language}>
                {language}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: initialHtml }}
        style={{
          backgroundColor: "#FEFEF9",
          padding: 24,
        }}
      />
    </div>
  )
}

export function getServerSideProps() {
  const htmlFilePath = path.resolve("./public", "terms-English.html")
  const initialHtmlContent = fs.readFileSync(htmlFilePath, "utf8")

  const htmlFilePathSvenska = path.resolve("./public", "terms-Svenska.html")
  const initialHtmlContentSvenska = fs.readFileSync(htmlFilePathSvenska, "utf8")

  return {
    props: { initialHtmlContent, initialHtmlContentSvenska },
  }
}

export default Terms
